import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { getLocalJSON, isValidStored } from '../_helpers/storage.util';
import { GlobalService } from '../Services/global.service';

export type OnboardingStep = 'bank' | 'subscription' | 'content';

@Injectable({
  providedIn: 'root',
})
export class OnboardingGuard implements CanActivate {
  constructor(private router: Router, private service: GlobalService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (!isValidStored('grw_login')) {
      return true;
    }

    const required = route.data?.['requireOnboarding'] as OnboardingStep | undefined;
    if (!required) {
      return true;
    }

    const login = getLocalJSON<any>('grw_login', {});
    const profileComplete = login.profile_complete == true;
    const stripeVerified = login.stripe_account_verify == true;
    const subscriptionAdded = login.subscription_added == true;

    if (!profileComplete) {
      this.service.dangerAlert('Please complete your profile first');
      return this.router.createUrlTree(['/edit-profile']);
    }

    if (required === 'bank') {
      return true;
    }

    if (!stripeVerified) {
      this.service.dangerAlert('Please link your bank account first');
      return this.router.createUrlTree(['/bank-account']);
    }

    if (required === 'subscription') {
      return true;
    }

    if (!subscriptionAdded) {
      this.service.dangerAlert('Please complete your Subscription detail');
      return this.router.createUrlTree(['/presentation']);
    }

    return true;
  }
}
